import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import { validateCustomerFields } from "MODULES/SalesOrders/components/shared/FormSections/CustomerSection/validate";
import { validateSellerFields } from "MODULES/SalesOrders/components/shared/FormSections/SellersSection/validate";
import { validateShippingFields } from "MODULES/SalesOrders/components/shared/FormSections/ShippingSection/validate";
import {
  OUTRIGHT_VALUE,
  REPAIR_FEE,
  SHIP_TO_COMPANY_DISABLED
} from "MODULES/SalesOrders/constants";
import {
  CITY,
  COMPANY_ID,
  COUNTRY,
  LINE1,
  LINE_ITEMS,
  POSTAL_CODE,
  RETURN_TO,
  SHIP_TO,
  STATE
} from "APP_ROOT/constants";
import { BILLING_ADDRESS } from "MODULES/companies/constants";
import { EXCHANGE_FEE, PRICE_PER_UNIT } from "MODULES/OutgoingQuotes/constants";
import { CONTAINER_FEE, HAZMAT_FEE } from "MODULES/PurchaseOrders/constants";
import { HAZMAT, SPECIAL_CONTAINER_REQ } from "MODULES/parts/constants";
import { CONDITION } from "MODULES/inventories/constants";

function validateLineItem(item, values) {
  if (values.flat_exchange) {
    item
      .validate(REPAIR_FEE)
      .satisfies(rules.required, rules.isLessThan(values.exchange_fee));
  }
  if (values.exchange_sale) {
    item.validate(EXCHANGE_FEE, OUTRIGHT_VALUE).satisfies(rules.required);
  } else {
    item
      .validate(PRICE_PER_UNIT)
      .satisfies(rules.isGreaterThan(0), rules.required);
  }

  item.validate(CONDITION).satisfies(rules.required);
  item
    .validate(HAZMAT_FEE)
    .satisfies(rules.requiredIfAnyDefined(HAZMAT), rules.isNumeric);
  item
    .validate(CONTAINER_FEE)
    .satisfies(
      rules.requiredIfAnyDefined(SPECIAL_CONTAINER_REQ),
      rules.isNumeric
    );
}

export default function validate(values, props) {
  const hasExchange = values.line_items.some(i => i.exchange_sale);

  return validator(values, form => {
    if (hasExchange) {
      validateShippingFields(RETURN_TO, values, form, false);
    }
    validateCustomerFields(values, form);
    validateSellerFields(values, form);
    validateShippingFields(SHIP_TO, values, form);
    form.validateChildren(LINE_ITEMS, validateLineItem);

    if (props.selectedCustomer) {
      form
        .validate(COMPANY_ID)
        .satisfies(() => rules.validateCompanyStatus(props.selectedCustomer));
    }
    form
      .validate(SHIP_TO_COMPANY_DISABLED)
      .satisfies(rules.shipToCompanyIsNoBiz);

    if (props.selectedCustomer && !props.selectedCustomer.billing_address) {
      form.validateChild(BILLING_ADDRESS, billingForm => {
        billingForm
          .validate(LINE1, CITY, STATE, POSTAL_CODE, COUNTRY)
          .satisfies(rules.required);
      });
    }
  });
}



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/ReserveForSale/ConvertDummyForm/validate.js